module.exports = __webpack_public_path__ + "static/media/Robot.f00abfa3.jpg";